import { executeSubmit } from 'fg-frontend/src/partialUpdate/partialUpdate';

var fg = fg || {};
var jQuery = $ = require('jquery');
require('./plupload.full');
var RamJetFileProgress = require('./fileProgressBar');


fg.Upload = function(element, options) {
  this.init(element, options);
}

fg.Upload.prototype.defaults = {
  // plupload options
  runtimes : 'html5,flash,html4',
  url : null,
  urlToRemove : null,
  flash_swf_url: null,
  autoStart: true,
  dragdrop: true,
  // file limits
  filters: [],
  max_file_size: 0,
  max_file_count: 0,
  max_file_queue_count: 0,
  // elements
  drop_element: null,
  statusDiv: null,
  progressTarget: null,
  progressWidth: null,
  // buttons
  browse_button: null,
  startQueueTarget: null,
  cancelQueueTarget: null,
  remove_button: null,
  // localization messages
  labelInQueue: undefined,
  labelUploading: undefined,
  labelComplete: undefined,
  labelStopped: undefined,
  labelCancelled: undefined,
  labelFileQueued: undefined,
  labelUploadCompleted: undefined,
  labelQueueCompleted: undefined,
  labelErrorUploadLimit: undefined,
  labelErrorQueueLimit: undefined,
  labelErrorFileTooBig: undefined,
  labelErrorZeroLength: undefined,
  labelErrorInvalidFileType: undefined,
  labelErrorUnknownError: undefined,
  labelErrorUploadError: undefined,
  // auto disappear uploaded files and error messages - time in ms, 0 for no disappear
  disappearUploadedFiles: 0,
  disappearErrors: 0
};

fg.Upload.Error = {
  'FILE_COUNT_ERROR': -9001,
  'FILE_QUEUE_COUNT_ERROR': -9002,
  'FILE_ZERO_BYTE_ERROR': -9003
};

$.fn.fgUpload = function(options) {
  var upload = new fg.Upload($(this), options);
  $(this).data('fgUpload', upload);
};

fg.Upload.prototype.init = function(element, options) {
  this.element = element;
  this.queue = [];
  this.alreadyCounted = false;
  this.options = $.extend({}, this.defaults, options);
  this.uploader = new plupload.Uploader(this.options);

  this.browseButton = $('#'+ this.options['browse_button']);
  this.startButton = $('#'+ this.options['startQueueTarget']);
  this.cancelButton = $('#'+ this.options['cancelQueueTarget']);
  this.removeButton = $('.'+ this.options['remove_button']);
  this.statusDiv = $('#'+ this.options['statusDiv']);
  this.dropElement = $('#'+ this.options['drop_element']);

  if (this.options['max_file_count']) {
    this.uploader.bind('FilesAdded', $.proxy(function(up, files) {
      var removed = [], selectedCount = files.length;
      var extraCount = up.files.length + selectedCount - this.options['max_file_count'];
      if (extraCount > 0) {
        removed = files.splice(selectedCount - extraCount, extraCount);
        //remove files from uploader queue
        $.each(removed, $.proxy(function(index, file){
          this.uploader.removeFile(file);
        }, this));
        up.trigger('Error', {
          code: fg.Upload.Error.FILE_COUNT_ERROR,
          message: ('File count error.'),
          file: removed
        });
      }
    }, this));
  }
  this.uploader.bind('Init', $.proxy(this.onInit, this));
  this.uploader.bind('Error', $.proxy(this.onError, this));

  this.uploader.init();

  this.uploader.bind('FilesAdded', $.proxy(this.onFilesAdded, this));
  this.uploader.bind('QueueChanged', $.proxy(this.onQueueChanged, this));
  this.uploader.bind('StateChanged', $.proxy(this.onStateChanged, this));
  this.uploader.bind('BeforeUpload', $.proxy(this.onBeforeUpload, this));
  this.uploader.bind('UploadFile', $.proxy(this.onUploadFile, this));
  this.uploader.bind('UploadProgress', $.proxy(this.onUploadProgress, this));
  this.uploader.bind('FileUploaded', $.proxy(this.onFileUploaded, this));
  this.uploader.bind('UploadComplete', $.proxy(this.onUploadComplete, this));
  this.removeButton.on('click', (event) => {
    event.preventDefault();
    var element = $(event.target);
    var fileId = element.data('file-id');
    this.removeFile(element, fileId);
  });
}

fg.Upload.prototype.onInit = function(up, res) {
  if (up.features.dragdrop && this.options['dragdrop']) {
    this.dropElement.show();
    this.dropElement.bind('dragenter', $.proxy(function(e) {
      this.dropElement.addClass('hover');
    }, this));
    this.dropElement.bind('dragleave drop', $.proxy(function(e) {
      this.dropElement.removeClass('hover');
    }, this));
    this.dropElement.on('drop', (e) => {
      // if ( e.dataTransfer.items) {
      e.preventDefault();
      e.stopPropagation();
      this.uploader.addFile(e.dataTransfer.items);
      return false;
      // }
    });
  } else {
    this.dropElement.hide();
  }
};

fg.Upload.prototype.onFilesAdded = function(up, files) {
  if (this.options['max_file_queue_count']) {
    var removed = [], selectedCount = files.length;
    if (selectedCount > this.options['max_file_queue_count']) {
      //remove files from uploader queue
      $.each(files, $.proxy(function(index, file){
        this.uploader.removeFile(file);
      }, this));
      up.trigger('Error', {
        code : fg.Upload.Error.FILE_QUEUE_COUNT_ERROR,
        file : removed
      });
      files = [];
      return;
    }
  }

  $.each(files, $.proxy(function(index, file){
    if (file.size == 0) {
      this.uploader.removeFile(file);
      up.trigger('Error', {
        code: fg.Upload.Error.FILE_ZERO_BYTE_ERROR,
        file: file,
        message: 'Zero byte file error.'
      });
    }
    if (file.status !== plupload.FAILED) {
      var progress = new RamJetFileProgress(
        file,
        this.options['progressTarget'],
        this.options['progressWidth']
      );
      progress.setStatus(this.options['labelInQueue']);
      progress.toggleCancel(true, this);

      this.queue[file.id] = {
        'progress': progress
      };
    }
  }, this));

  if (this.options['autoStart']) {
    // set a little delay to make sure that QueueChanged triggered by the core has time to complete
    setTimeout($.proxy(function() {
      this.uploader.start();
    },this), 10);
  }

  this.startButton.removeAttr('disabled').bind('click',  $.proxy(function() {
    this.uploader.start();
    return false;
  }, this));
};

fg.Upload.prototype.onQueueChanged = function(up) {
  this.refreshQueueCount(up);
  this.uploadGuardedForm(up);
};

fg.Upload.prototype.onStateChanged = function(up){
  if (up.state === plupload.STARTED){
    this.cancelButton.show();
    this.startButton.hide();
    this.browseButton.attr('disabled', 'disabled').addClass('disabled');
    this.cancelButton.bind('click', $.proxy(function(){
      this.uploader.stop();
    }, this));
  } else {
    this.cancelButton.hide();
    this.startButton.show();
    this.browseButton.removeAttr('disabled').removeClass('disabled');
  }
};

fg.Upload.prototype.onBeforeUpload = function(up, file){
  var progress = this.queue[file.id]['progress'];
  progress.setStatus(this.options['labelUploading']);
  progress.toggleCancel(true, this);
};

fg.Upload.prototype.onUploadFile = function(up, file){

};

fg.Upload.prototype.onUploadProgress = function(up, file){
  var progress = this.queue[file.id]['progress'];
  var percent = file.percent;
  progress.setProgress(percent);
  progress.setStatus(this.options['labelUploading']);
};

fg.Upload.prototype.onFileUploaded = function(up, file, response){
  var progress = this.queue[file.id]['progress'];
  progress.setComplete(this.options['disappearUploadedFiles']);
  progress.setStatus(this.options['labelComplete']);
  progress.toggleCancel(false);
};

fg.Upload.prototype.onUploadComplete = function(up, params){
  this.startButton.attr('disabled', 'disabled');
  this.refreshUploadCount(up);
  this.uploadGuardedForm(up);

  executeSubmit({
    submitId: $(this.element).parents('form').attr('id'),
    url: this.options['formUrl'],
    target: 'partialUpdateContainer',
    moveUrlQueryParamsToFormDataOnPost: true,
  });
};

fg.Upload.prototype.cancelUpload = function(fileId){
  var file = this.uploader.getFile(fileId);
  this.uploader.removeFile(file);
  var progress = this.queue[fileId]['progress'];
  progress.setCancelled(100);
};

fg.Upload.prototype.onError = function(up, error){
  var message = error.message || '';
  var file = error.file;

  if (file !== undefined) {
    var progress = new RamJetFileProgress(file, this.options['progressTarget'], this.options['progressWidth']);
    progress.setError(this.options['disappearErrors']);
  }

  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    "/": '&#x2F;',
  };
  var reg = /[&<>"'/]/ig;
  var fileName = file.name.replace(reg, (match)=>(map[match]));

  switch (error.code) {
    case plupload.INIT_ERROR:
      this.destroy();
      break;
    case plupload.FILE_SIZE_ERROR:
      progress.setStatus(this.options['labelErrorFileTooBig']);
      message = "Error Code: FILE_SIZE_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
      break;
    case plupload.FILE_EXTENSION_ERROR:
      progress.setStatus(this.options['labelErrorInvalidFileType']);
      message = "Error Code: FILE_EXTENSION_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
      break;
    case plupload.HTTP_ERROR:
      progress.setStatus(this.options['labelErrorUploadError'] + " (" + message + ")");
      message = "Error Code: HTTP_ERROR, File name: " + fileName + ", Message: " + message;
      break;
    case fg.Upload.Error.FILE_COUNT_ERROR:
      progress.setStatus(this.options['labelErrorUploadLimit']);
      progress.setLabel(this.options['labelStopped']);
      message = "Error Code: FILE_COUNT_ERROR, Max file count: " + this.options['max_file_count'] + ", Message: " + message;
      break;
    case fg.Upload.Error.FILE_QUEUE_COUNT_ERROR:
      progress.setStatus(this.options['labelErrorQueueLimit']);
      progress.setLabel(this.options['labelStopped']);
      message = "Error Code: FILE_QUEUE_COUNT_ERROR, Max file count for queue: " + this.options['max_file_queue_count']+ ", Message: " + message;
      break;
    case fg.Upload.Error.FILE_ZERO_BYTE_ERROR:
      progress.setStatus(this.options['labelErrorZeroLength']);
      message = "Error Code: FILE_ZERO_BYTE_ERROR, File name: " + fileName + ", File size: " + file.size + ", Message: " + message;
      break;
    default:
      if (file !== null) {
        progress.setStatus(this.options['labelErrorUploadError']);
      }
      message = "Error Code: " + error.code + ", File name: " + fileName + ", File size: " + file.size+ ", Message: " + message;
      break;
  }
  this.debug(message);
};

fg.Upload.prototype.refreshQueueCount = function (up) {
  var filesInQueue = up.total.queued;

  this.statusDiv.html(this.options.labelFileQueued.replace("{0}", filesInQueue));
  if (filesInQueue == 0) {
    this.refreshUploadCount(up);
  }
};

fg.Upload.prototype.refreshUploadCount = function (up) {
  this.statusDiv.html(this.options.labelQueueCompleted.replace("{0}", up.total.uploaded));
};

fg.Upload.prototype.destroy = function () {
  // unbind all button events
  this.startButton.unbind();
  this.cancelButton.unbind();
  // destroy uploader instance
  this.uploader.destroy();
  this.element.hide();
  // show alternative content
  $('#'+ this.element.attr('id').replace('__container', '__noscript_container')).show();
};

fg.Upload.prototype.SubmitForm = function(envelopingForm) {
  var envelopingFormCls = envelopingForm;

  this.monitorSubmit = function(event) {
    var pluploads = envelopingFormCls.data().pluploads;
    for (var i = 0; i < pluploads.length; i++) {
      if (!(pluploads[i].state === plupload.STARTED)) {
        pluploads[i].start();
      }
    }
    envelopingFormCls.data("formSubmitRequested", event.target);
    //disable all the submit buttons in the form
    var submitsCls = envelopingFormCls.find("input[type=submit]");
    submitsCls.filter("[disabled!=disabled]")
      .addClass("disabledByPlupload")
      .attr("disabled", "disabled");
    return false;
  };
  this.unbind = function() {
    var existingGuard = envelopingFormCls.data().uploadGuardedForm;
    var submitsCls = envelopingFormCls.find("input[type=submit]");
    envelopingFormCls.unbind("submit", existingGuard.monitorSubmit );
    submitsCls.unbind("click", existingGuard.monitorSubmit);
    submitsCls.filter(".disabledByPlupload")
      .removeClass("disabledByPlupload")
      .removeAttr("disabled");
  };
  this.bind = function() {
    envelopingFormCls.bind("submit", $.proxy(this.monitorSubmit, this));
    //disable all the submit buttons in the form
    var submitsCls = envelopingFormCls.find("input[type=submit]");
    submitsCls.bind("click", this.monitorSubmit);
  };
  this.addPluploadToMonitor = function(plupload) {
    envelopingFormCls.data().pluploads.push(plupload);
  };
  this.removePluploadToMonitor = function(plupload) {
    envelopingFormCls.data().pluploads.pop();
  };
  this.hasAnyPluploads = function() {
    return envelopingFormCls.data().pluploads.length > 0;
  };
};

fg.Upload.prototype.uploadGuardedForm = function (up) {
  var envelopingForm = this.element.parents("form");
  if (envelopingForm.length > 0) {
    var existingGuard = envelopingForm.data().uploadGuardedForm;
    if(up.total.queued > 0) {
      if (existingGuard === undefined || existingGuard === null) {
        //disable submit of the form
        existingGuard = new this.SubmitForm(envelopingForm);
        envelopingForm.data("uploadGuardedForm", existingGuard);
        envelopingForm.data("pluploads", new Array());
        envelopingForm.data("formSubmitRequested", null);
        existingGuard.bind();
        if (this.alreadyCounted !== true) {
          existingGuard.addPluploadToMonitor(up);
          this.alreadyCounted = true;
        }
      } else {
        if (this.alreadyCounted !== true) {
          existingGuard.addPluploadToMonitor(up);
          this.alreadyCounted = true;
        }
      }
    } else {
      if (existingGuard !== undefined || existingGuard !== null) {
        existingGuard.removePluploadToMonitor(up);
        if (!existingGuard.hasAnyPluploads()) {
          //enable submit of the form again
          existingGuard.unbind();
          if (envelopingForm.data().formSubmitRequested !== null) {
            var fsr = envelopingForm.data().formSubmitRequested;
            envelopingForm.data("uploadGuardedForm", null);
            envelopingForm.data("pluploads", null);
            envelopingForm.data("formSubmitRequested", null);
            if (fsr.tagName.toUpperCase() == "INPUT") {
              setTimeout(function () {
                fsr.click();
              }, 2000);
            } else if (fsr.tagName.toUpperCase() == "FORM") {
              setTimeout(function () {
                fsr.submit();
              }, 2000);
            }
          }
        }
      }
    }

  }
};

fg.Upload.prototype.debug = function(message){
  if (window.console) {
    console.log(message);
  }
};

fg.Upload.prototype.removeFile = function(element, fileId){
  $.post(this.options.urlToRemove + "&fileId=" + fileId, function () {
    element.parents('.ramJetProgressWrapper').remove();
  });
};



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/components/plUpload/fg.upload.js